// PCM Colors - Exact codes from client
const pcmColors = {
  Analyseur: { bg: "bg-[#32A2FF]", text: "text-white", hex: "#32A2FF" },          // Bleu ciel
  Persévérant: { bg: "bg-[#7F379D]", text: "text-white", hex: "#7F379D" },        // Violet
  Empathique: { bg: "bg-[#FC7403]", text: "text-white", hex: "#FC7403" },         // Orange
  Énergiseur: { bg: "bg-[#FAE200]", text: "text-[#1a365d]", hex: "#FAE200" },     // Jaune
  Promoteur: { bg: "bg-[#FF1933]", text: "text-white", hex: "#FF1933" },          // Rouge
  Imagineur: { bg: "bg-[#E3A88D]", text: "text-[#1a365d]", hex: "#E3A88D" },      // Marron clair
};

const pcmIcons = {
  Analyseur: "📊",
  Persévérant: "🎯",
  Empathique: "💚",
  Énergiseur: "⚡",
  Promoteur: "🚀",
  Imagineur: "💭",
};

const PCMBadge = ({ type, label, size = "md", className = "" }) => {
  const colors = pcmColors[type] || { bg: "bg-slate-500", text: "text-white", hex: "#64748B" };
  const icon = pcmIcons[type] || "•";

  const sizeClasses = {
    sm: "px-2 py-1 text-xs",
    md: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base",
  };

  return (
    <span
      className={`inline-flex items-center font-medium rounded-lg ${colors.bg} ${colors.text} ${sizeClasses[size]} ${className}`}
      data-testid={`pcm-badge-${type?.toLowerCase().replace('é', 'e')}`}
    >
      <span className="mr-1.5">{icon}</span>
      {type}
      {label && <span className="ml-1.5 opacity-80">({label})</span>}
    </span>
  );
};

export const getPCMColor = (type) => {
  return pcmColors[type]?.hex || "#64748B";
};

export const pcmColorMap = pcmColors;

export default PCMBadge;
